/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* Coffret douceur - ajout depuis le cart drawer */
(function () {
  if (window.coffretDouceurUpsellInitialized) return;
  window.coffretDouceurUpsellInitialized = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.coffret-upsell__button');

    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    const originalText = button.textContent;

    if (!variantId) return;

    button.disabled = true;
    button.textContent = 'Ajout en cours...';

    try {
      const root =
        window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Impossible d’ajouter le coffret.');
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );
    } catch (error) {
      console.error(error);

      button.disabled = false;
      button.textContent = originalText;

      alert("Une erreur est survenue lors de l’ajout du Coffret douceur.");
    }
  });
})();
/* Coffret douceur — replier / rouvrir sur mobile */
(function () {
  const STORAGE_KEY = 'coffretDouceurCollapsed';

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function applyCoffretState() {
    document.querySelectorAll('.coffret-upsell').forEach(function (coffret) {
      const closeButton = coffret.querySelector('.coffret-upsell__close');
      const compactButton = coffret.nextElementSibling &&
        coffret.nextElementSibling.classList.contains('coffret-upsell__compact')
          ? coffret.nextElementSibling
          : null;

      if (!compactButton) return;

      /* Sur ordinateur, garder toujours le coffret ouvert */
      if (!isMobile()) {
        coffret.hidden = false;
        closeButton.setAttribute('hidden', '');
        compactButton.setAttribute('hidden', '');
        return;
      }

      const isCollapsed =
        sessionStorage.getItem(STORAGE_KEY) === 'true';

      if (isCollapsed) {
        coffret.hidden = true;
        closeButton.setAttribute('hidden', '');
        compactButton.removeAttribute('hidden');
      } else {
        coffret.hidden = false;
        closeButton.removeAttribute('hidden');
        compactButton.setAttribute('hidden', '');
      }
    });
  }

  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest('.coffret-upsell__close');

    if (closeButton) {
      event.preventDefault();
      sessionStorage.setItem(STORAGE_KEY, 'true');
      applyCoffretState();
      return;
    }

    const compactButton = event.target.closest('.coffret-upsell__compact');

    if (compactButton) {
      event.preventDefault();
      sessionStorage.setItem(STORAGE_KEY, 'false');
      applyCoffretState();
    }
  });

  window.addEventListener('resize', applyCoffretState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCoffretState);
  } else {
    applyCoffretState();
  }

  /* Prestige reconstruit parfois le panier dynamiquement */
  const observer = new MutationObserver(function () {
    applyCoffretState();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();